import React, { useContext } from 'react'
import styled from 'styled-components'
import { Route, Switch, useLocation } from 'react-router-dom'
import { AppContext } from '../context/AppContext'
import { CourseOverview } from './CourseOverview'
import useCourseRetriever from '../hooks/useCourseRetriever'
import { Loader } from './Loader'
import Lesson from './Lesson'
import useStripeKey from '../hooks/useStripeKey'
import { CourseRefresh } from './CourseRefresh'

export const CourseRouter = () => {
  const location = useLocation()
  const { appState } = useContext(AppContext)
  useCourseRetriever(window.TTI_COURSE_ID)
  useStripeKey()

  return (
    <Container>
      {appState.isCourseLoading && !appState.course && (
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      )}
      {appState.course && (
        <Switch location={location}>
          <Route exact path="/courses/:course/">
            <CourseOverview course={appState.course} />
          </Route>
          <Route exact path="/courses/:courseKey/:unitKey/:lessonKey">
            <Lesson />
          </Route>
          <Route default>
            <CourseOverview course={appState.course} />
          </Route>
        </Switch>
      )}
      {appState.refreshTime && (
        <CourseRefresh time={appState.refreshTime} />
      )}
    </Container>
  )
}

const Container = styled.div`
  flex: 1;
  overflow: hidden;
  background: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.text};
`

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`